import ObjectID from 'bson-objectid';

import type { GenericId, Id } from '@e-socna/data-layer';

export type GenerateId = <I extends Id = GenericId>() => I;

export const generateId = <I extends Id = GenericId>() =>
  ObjectID().toHexString() as I;
